const PaintBoardIcon = ({ className, fill }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1.04163C5.05247 1.04163 1.04169 5.05241 1.04169 9.99996C1.04169 14.9475 5.05247 18.9583 10 18.9583C10.0429 18.9583 10.092 18.959 10.1458 18.9598L10.1462 18.9598H10.1462C10.446 18.9643 10.8948 18.9709 11.2648 18.8674C11.5048 18.8002 11.7763 18.6732 11.985 18.4228C12.1997 18.1652 12.2917 17.8449 12.2917 17.5C12.2917 16.7989 11.932 16.2669 11.6857 15.9026L11.6587 15.8626C11.4556 15.5613 11.3306 15.3652 11.2763 15.159C11.2325 14.9925 11.226 14.7789 11.3924 14.4461C11.5926 14.0457 11.8239 13.8847 12.1342 13.7946C12.5086 13.6859 12.9942 13.6805 13.7346 13.6805H13.7442C14.4522 13.6805 15.3222 13.6805 16.3384 13.5353C17.3426 13.3919 18.0578 12.9872 18.483 12.2844C18.8795 11.6291 18.9584 10.8123 18.9584 9.99996C18.9584 5.05241 14.9476 1.04163 10 1.04163ZM5.61506 11.6972C5.17253 11.8163 4.90992 12.2732 5.02849 12.7178C5.14707 13.1623 5.60193 13.4262 6.04445 13.307L6.05165 13.3051C6.49418 13.186 6.75679 12.729 6.63822 12.2845C6.51964 11.8399 6.06478 11.5761 5.62225 11.6952L5.61506 11.6972ZM6.04169 7.08329C6.04169 6.04776 6.88115 5.20829 7.91669 5.20829C8.95222 5.20829 9.79169 6.04776 9.79169 7.08329C9.79169 8.11883 8.95222 8.95829 7.91669 8.95829C6.88115 8.95829 6.04169 8.11883 6.04169 7.08329ZM13.75 6.04163C12.7145 6.04163 11.875 6.88109 11.875 7.91663C11.875 8.95216 12.7145 9.79163 13.75 9.79163C14.7856 9.79163 15.625 8.95216 15.625 7.91663C15.625 6.88109 14.7856 6.04163 13.75 6.04163Z"
        fill={fill || "#888888"}
      />
    </svg>
  );
};

export default PaintBoardIcon;
